export enum COOKIE_NAME {
  IS_AUTHENTICATED = 'is_authenticated',
  IS_REGISTERED = 'is_registered',
  ACTIVE_SESSION = 'active_session',
  USER_IP = 'user-ip',
  STAG = 'stag',
  // For testing purposes
  CUSTOM_IP = 'custom_ip',
}
